import Swal from 'sweetalert2'
import { hapiickApi } from '../api/hapiickApi'

const openModal = async (stock_product_id, administrator_id) => {
    if (!validateInputData(stock_product_id, administrator_id)) {
        return false
    }

    let reservations = await getColumnsReservationsByUSer(administrator_id)

    let firstOption = ''
    if (reservations[0] === 'ERROR') {
        firstOption = '<option value="">No se han podido obtener tus reservas</option>'
        reservations = []
    } else {
        firstOption = (reservations.length === 0) ? '<option value="">No tienes reservas</option>' : '<option value="">Selecciona una reserva</option>'
    }

    let inputOptions = reservations.map((a) => `<option value=${a.id}>${a.name}</option>`).join('')

    return Swal.fire({
        title: "Crea una nueva reserva o selecciona una existente",
        html: `
            <div class="swal-custom">
            <div class="ui form">
                <div class="field">
                <input id="swal-input" type="text" class="ui fluid input" placeholder="Nueva reserva">
                </div>
                <div class="field">
                <select id="swal-select" class="ui fluid dropdown">
                    ${firstOption}
                    ${inputOptions}
                </select>
                </div>
                <div class="field"></div>
            </div>
            </div>
        `,
        focusConfirm: false,
        showCancelButton: true,
        onOpen: () => {
            document.getElementById("swal-input").addEventListener("input", () => Swal.resetValidationMessage());
            document.getElementById("swal-select").addEventListener("change", () => Swal.resetValidationMessage());
        },
        preConfirm: async () => {
            const input = document.getElementById("swal-input").value.trim();
            const select = document.getElementById("swal-select").value;

            if (!input && !select) {
                Swal.showValidationMessage("Debes crear una nueva reserva o seleccionar una existente")
                return
            } else if (input && select) {
                Swal.showValidationMessage("Debes indicar solo uno de los campos")
                return
            } else if (input && reservations.some(a => a.name === input)) {
                Swal.showValidationMessage("Ya tienes una reserva con el mismo nombre")
                return
            }

            let data = {
                admin_id: administrator_id,
                stock_product_id: stock_product_id,
                ...(input ? { column_reservation_name: input } : { column_reservation_id: select })
            }

            return await newColumnReservation(data)
        }
    }).then((result) => {
        if (result.dismiss) {
            return undefined
        } else {
            return result.value

        }
    })
}

const newColumnReservation = async (data) => {
    return hapiickApi().post('/v1/stocks/products/reserve', {
        ...data
    })
        .then((response) => response.data.status === 'OK')
        .catch((error) => {
            console.log(`Error newColumnReservation: ${error}`)
            return false
        })
}

const validateInputData = (stock_product_id, administrator_id) => {

    return (!isNaN(stock_product_id) && stock_product_id > 0 && !isNaN(administrator_id) && administrator_id > 0)

}

const getColumnsReservationsByUSer = async (administrator_id) => {

    return hapiickApi().post('/v1/reservations/admin', {
        admin_id: administrator_id
    })
        .then(response => response.data.reservations)
        .catch(error => {
            console.log(`Error getColumnsReservations: ${error}`)
            return ['ERROR']
        })
}

export default {

    openModal

}



// WEBPACK FOOTER //
// ./src/tools/BookingModal.js